import { render } from "./DescribeAllIngredients.vue?vue&type=template&id=2b7fd503"
import script from "./DescribeAllIngredients.vue?vue&type=script&lang=js"
export * from "./DescribeAllIngredients.vue?vue&type=script&lang=js"
script.render = render

export default script